import { Typography } from '@mui/material';
import type { Currency, PlanInputFormFixedProduct } from '@vy/types';
import React from 'react';
import { PromotionItem } from './PromotionItem';

type PromotionsSectionProps = {
  promotions: PlanInputFormFixedProduct[];
  currency: Currency;
};

export const PromotionsSection: React.FC<PromotionsSectionProps> = ({ promotions, currency }) => {
  return (
    <section>
      <Typography
        variant="overline"
        sx={{
          color: "text.secondary",
          fontWeight: 300
        }}>
        Promotions
      </Typography>
      <ul className="mt-4 space-y-8">
        {promotions.map((promotion) => (
          <PromotionItem key={promotion.id} promotion={promotion} currency={currency} />
        ))}
      </ul>
    </section>
  );
};
